module.exports = __webpack_public_path__ + "static/media/onboarding-history.en.da849de7.png";